module.exports = __webpack_public_path__ + "bbd23257a09e0371e4fd0ae99db4ea50.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_1_tri.mp3
 ** module id = 169
 ** module chunks = 0
 **/